export default __webpack_public_path__ + "static/media/edit.91f7f9f1.svg";